import { Translation } from "i18n/config";
import { ChallengeSearcherTranslation } from "./typing";

export const ChallengeSearcherTexts: Translation<ChallengeSearcherTranslation> = {
	es: {
		intro: "Bienvenido a la cuarta revolución industrial: Retos.",
		title: "Invitaciones a Retos",
		desc: "Aquí aparecen los retos que has sido invitado",
		invitesForChallenges: "Invitaciones a Retos",
		hereAppearsTheChallengesThatYouHaveBeenInvited: "Aquí aparecen los retos que has sido invitado/a",
		thereIsntAnyChallenge: "No tiene todavía ningún reto",
		seeOnlyMyInvitationsToChallenges: "Ver sólo mis invitaciones a Retos",
		seeAllChallenges: "Ver todos los Retos",
		challengesCreatedBy: "Retos creados por:",
		universities: "Universidades",
		institutions: "Instituciones",
		companies: "Empresas",
		incubators: "Incubadoras",
		accelerators: "Aceleradoras",
		type: "Tipo",
		product: "Producto",
		service: "Servicio",
	},
	en: {
		intro: "Welcome to the fourth industrial revolution: Challenges.",
		title: "Challenge Invitations",
		desc: "Here are the challenges that you have been invited ",
		invitesForChallenges: "Challenge Invitations",
		hereAppearsTheChallengesThatYouHaveBeenInvited: "Here are the challenges that you have been invited",
		thereIsntAnyChallenge: "You have no challenge yet",
		seeOnlyMyInvitationsToChallenges: "See only my invitations to Challenges",
		seeAllChallenges: "See all Challenges",
		challengesCreatedBy: "Challenges created by:",
		universities: "Universities",
		institutions: "Institutions",
		companies: "Companies",
		incubators: "Incubators",
		accelerators: "Accelerators",
		type: "Type",
		product: "Product",
		service: "Service",
	},
	ca: {
		intro: "Benvingut a la quarta revolució industrial: Challenges.",
		title: "Invitacions a Reptes",
		desc: "Aquí apareixen els reptes que has estat convidat",
		invitesForChallenges: "Invitacions a Reptes",
		hereAppearsTheChallengesThatYouHaveBeenInvited: "Aquí apareixen els reptes que has estat convidat/a",
		thereIsntAnyChallenge: "No té encara cap repte",
		seeOnlyMyInvitationsToChallenges: "Veure només els meus invitacions a Reptes",
		seeAllChallenges: "Veure totes les Challenges",
		challengesCreatedBy: "Reptes creats per:",
		universities: "Universitats",
		institutions: "Institucions",
		companies: "Empreses",
		incubators: "Incubadores",
		accelerators: "Acceleradores",
		type: "Tipu",
		product: "Producte",
		service: "Servei",
	},
	pt: {
		intro: "Bem-vindo à quarta revolução industrial: desafios.",
		title: "Convites de desafio",
		desc: "Aqui aparecem os desafios que você foi convidado",
		invitesForChallenges: "Convites de desafio",
		hereAppearsTheChallengesThatYouHaveBeenInvited: "Aqui estão os desafios para os quais você foi convidado/a",
		thereIsntAnyChallenge: "Você ainda não tem nenhum desafio",
		seeOnlyMyInvitationsToChallenges: "Veja apenas meus convites para os Desafios",
		seeAllChallenges: "Veja todos os desafios",
		challengesCreatedBy: "Desafios criados por:",
		universities: "Universidades",
		institutions: "Instituições",
		companies: "Empresas",
		incubators: "Incubadoras",
		accelerators: "Aceleradores",
		type: "Tipo",
		product: "Produto",
		service: "Serviço",
	},
};
